
define('template!pimProductsListTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="content">\n  <div class="well jq-grid-table-page">\n    <h2>' +
((__t = ( _.i18n('menu.pim') )) == null ? '' : __t) +
'</h2>\n    <div class="product-filters selected-attributes-region">\n\n    </div>\n    <div class="pim-filter-actions">\n      <button class="show-filter-button pim-filter-btn">Show filters</button>\n      <button class="hide-filter-button pim-filter-btn" style="display: none;">Hide filters</button>\n      <button class="filter-button pim-filter-btn pim-filter-btn--primary" style="display: none;">Apply filters</button>\n      <button class="clear-filter-button pim-filter-btn pim-filter-btn--outline" style="display: none;">Clear filters</button>\n    </div>\n    <div class="sub-caccounts-table">\n      <table id="jq-grid-list" class="cacountTable products-table" role="grid"></table>\n      <div id="jq-grid-pager-list"></div>\n    </div>\n  </div>\n</div>\n<div class="loader-3" style="display: none"></div>\n';

}
return __p
};});

